import * as CONSTANT from './../base/constant';
import * as EVENTS from './../../common/constant';
/**
 * Link internal component
 *
 * @hidden
 * @private
 */
export class ClearFormat {
    /**
     * Constructor for creating the clear format plugin
     *
     * @param {MarkdownParser} parent - specifies the parent element
     * @hidden
     * @private
     */
    constructor(parent) {
        this.parent = parent;
        this.selection = this.parent.markdownSelection;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(CONSTANT.CLEAR_COMMAND, this.clear, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(CONSTANT.CLEAR_COMMAND, this.clear);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    }
    replaceRegex(data) {
        /* eslint-disable */
        return data.replace(/\*/ig, '\\*').replace(/\&/ig, '\\&')
            .replace(/\-/ig, '\\-').replace(/\^/ig, '\\^')
            .replace(/\$/ig, '\\$').replace(/\./ig, '\\.')
            .replace(/\|/ig, '\\|').replace(/\?/ig, '\\?')
            .replace(/\+/ig, '\\+').replace(/\-/ig, '\\-')
            .replace(/\&/ig, '\\&');
        /* eslint-enable */
    }
    clearSelectionTags(text) {
        const data = this.parent.selectionTags;
        const keys = Object.keys(data);
        for (let num = 0; num < keys.length; num++) {
            const key = keys[num];
            if (Object.prototype.hasOwnProperty.call(data, key) && data[`${key}`] !== '') {
                const expString = this.replaceRegex(data[`${key}`]);
                let regExp;
                const startExp = data[`${key}`].length;
                const endExp = (data[`${key}`] === '<sup>' || data[`${key}`] === '<sub>') ? data[`${key}`].length + 1 : data[`${key}`].length;
                if (data[`${key}`] === '<sup>') {
                    // eslint-disable-next-line
                    regExp = new RegExp('<sup>(.*?)<\/sup>', 'ig');
                }
                else if (data[`${key}`] === '<sub>') {
                    // eslint-disable-next-line
                    regExp = new RegExp('<sub>(.*?)<\/sub>', 'ig');
                }
                else {
                    const regExpr = RegExp;
                    regExp = new regExpr(expString + '(.*?)' + expString, 'ig');
                }
                const val = text.match(regExp);
                for (let index = 0; val && index < val.length && val[index] !== ''; index++) {
                    // eslint-disable-next-line max-len
                    text = text.replace(val[index], val[index].substr(startExp, val[index].length - endExp - startExp));
                }
            }
        }
        return text;
    }
    clearFormatTags(text) {
        const lines = text.split('\n');
        return this.clearFormatLines(lines);
    }
    clearFormatLines(lines) {
        const tags = [this.parent.formatTags, this.parent.listTags];
        let str = '';
        for (let len = 0; len < lines.length; len++) {
            for (let num = 0; num < tags.length; num++) {
                const data = tags[num];
                const keys = Object.keys(data);
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    if (Object.prototype.hasOwnProperty.call(data, key) && data[`${key}`] !== '') {
                        if (lines[len].indexOf(data[`${key}`]) === 0) {
                            lines[len] = lines[len].replace(data[`${key}`], '');
                            lines[len] = this.clearFormatLines([lines[len]]);
                        }
                    }
                }
            }
            str = str + lines[len] + ((len !== lines.length - 1) ? '\n' : '');
        }
        return str;
    }
    clear(e) {
        const textArea = this.parent.element;
        textArea.focus();
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;
        let text = this.selection.getSelectedText(textArea);
        text = this.clearSelectionTags(text);
        text = this.clearFormatTags(text);
        textArea.value = textArea.value.substr(0, start)
            + text + textArea.value.substr(end, textArea.value.length);
        this.parent.markdownSelection.setSelection(textArea, start, start + text.length);
        this.restore(textArea, start, start + text.length, e);
    }
    restore(textArea, start, end, event) {
        this.selection.save(start, end);
        this.selection.restore(textArea);
        if (event && event.callBack) {
            event.callBack({
                requestType: event.subCommand,
                selectedText: this.selection.getSelectedText(textArea),
                editorMode: 'Markdown',
                event: event.event
            });
        }
    }
    destroy() {
        this.removeEventListener();
    }
}
